"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SiteMessageType = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactResponsiveCarousel = require("react-responsive-carousel");
var _core = require("core.ui-module_site-components");
var _SiteMessaging = require("../api/messaging/SiteMessaging");
require("react-responsive-carousel/lib/styles/carousel.min.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable prefer-destructuring */

const SiteMessageType = exports.SiteMessageType = Object.freeze({
  LOGIN_TOP: 1,
  LOGIN_MIDDLE: 2,
  DASHBOARD_TOP: 3,
  DASBOARD_MIDDLE: 4,
  DASHBOARD_BOTTOM: 5,
  SITE_HEADER: 6,
  SITE_FOOTER: 7
});

// eslint-disable-next-line import/prefer-default-export, no-unused-vars
const SiteMessages = /*#__PURE__*/(0, _react.forwardRef)((_ref,
// eslint-disable-next-line no-unused-vars
ref) => {
  let {
    type,
    showSpinner = false,
    carousel = false,
    arrows = false,
    thumbs = false,
    status = false,
    infinite = true,
    autoPlay = true,
    interval = 15000,
    transitionTime = 750,
    ...rest
  } = _ref;
  const [loading, setLoading] = (0, _react.useState)(false);
  const [messages, setMessages] = (0, _react.useState)(null);
  const classNames = (0, _core.useClassNames)(rest);
  (0, _react.useEffect)(() => {
    let msgFunction = null;
    if (type === SiteMessageType.LOGIN_TOP) {
      msgFunction = _SiteMessaging.getLoginTopMessages;
    } else if (type === SiteMessageType.LOGIN_MIDDLE) {
      msgFunction = _SiteMessaging.getLoginMiddleMessages;
    } else if (type === SiteMessageType.DASHBOARD_TOP) {
      msgFunction = _SiteMessaging.getDashboardTopMessages;
    } else if (type === SiteMessageType.DASHBOARD_MIDDLE) {
      msgFunction = _SiteMessaging.getDashboardMiddleMessages;
    } else if (type === SiteMessageType.DASHBOARD_BOTTOM) {
      msgFunction = _SiteMessaging.getDashboardBottomMessages;
    }
    setLoading(true);
    msgFunction().then(response => {
      setMessages(response.data);
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  }, []);
  if (loading && showSpinner) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "is-full-width has-text-centered"
    }, /*#__PURE__*/_react.default.createElement(_core.Spinner, null));
  }
  const renderCell = (column, cell) => /*#__PURE__*/_react.default.createElement(_core.Column, {
    className: column?.columnSize,
    mt: cell?.spacing?.marginTop,
    mb: cell?.spacing?.marginBottom,
    ml: cell?.spacing?.marginLeft,
    mr: cell?.spacing?.marginRight,
    pt: cell?.spacing?.paddingTop,
    pb: cell?.spacing?.paddingBottom,
    pl: cell?.spacing?.paddingLeft,
    pr: cell?.spacing?.paddingRight,
    flexAlignItems: (cell?.position?.align || column.align)?.toLowerCase(),
    flexJustifyContent: (cell?.position?.justify || column.justify)?.toLowerCase()
  }, cell && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, cell?.actionType ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, cell.actionType === 'BUTTON' && /*#__PURE__*/_react.default.createElement(_core.Button, {
    renderAs: cell.renderAs,
    size: cell.size,
    href: cell.url,
    target: cell.target,
    outlined: cell.outlined,
    inverted: cell.inverted,
    fullWidth: cell.fullWidth,
    rel: cell.rel
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "pl-1"
  }, cell.text))) : /*#__PURE__*/_react.default.createElement(_core.Content, {
    text: cell.value
  })));
  const renderGridMessage = message => {
    const totalColumns = message.grid.columns.length;
    let totalRows = 1;
    const allCells = [];
    if (message?.cells) {
      allCells.push(...message.cells);
    }
    if (message?.actions) {
      allCells.push(...message.actions);
    }
    if (allCells.length > 0) {
      allCells.forEach(cell => {
        if (cell.position.row > totalRows) {
          totalRows = cell.position.row;
        }
      });
    }
    const grid = [...new Array(totalRows)].map(() => [...new Array(totalColumns)]);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classNames || undefined
    }, message?.styleSheetUrl && /*#__PURE__*/_react.default.createElement("link", {
      rel: "stylesheet",
      href: message.styleSheetUrl
    }), /*#__PURE__*/_react.default.createElement(_core.Block, {
      className: message.styleSheetId,
      backgroundColor: message.backgroundColor,
      textColor: message.textColor
    }, grid.map((row, index) => /*#__PURE__*/_react.default.createElement(_core.Row, null, /*#__PURE__*/_react.default.createElement(_core.Columns, {
      className: message.grid.className,
      flexAlignItems: message.grid?.align?.toLowerCase(),
      flexJustifyContent: message.grid?.justify?.toLowerCase()
    }, row.map((ignore, colIndex) => {
      const column = message.grid.columns[colIndex];
      const cells = allCells.filter(cell => cell.position.row === index + 1 && cell.position.column === colIndex + 1);
      let cell = null;
      if (cells.length > 0) {
        cell = cells[0];
      }
      return renderCell(column, cell);
    }))))));
  };
  const renderMessage = message => {
    if (message?.grid) {
      return renderGridMessage(message);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classNames || undefined
    }, /*#__PURE__*/_react.default.createElement(_core.Block, {
      backgroundColor: message?.backgroundColor ? message.backgroundColor.toLowerCase() : 'teal',
      textColor: message?.textColor ? message.textColor.toLowerCase() : 'white'
    }, /*#__PURE__*/_react.default.createElement(_core.Columns, null, /*#__PURE__*/_react.default.createElement(_core.Column, {
      className: "is-align-items-center ml-5 mr-1",
      isNarrow: true
    }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
      name: message?.icon ? message.icon : 'campaign',
      size: 2
    })), /*#__PURE__*/_react.default.createElement(_core.Column, {
      className: "has-text-left"
    }, message?.messageTitle && /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, message.messageTitle)), /*#__PURE__*/_react.default.createElement(_core.Content, {
      text: message.text
    })))));
  };
  if (carousel) {
    return /*#__PURE__*/_react.default.createElement(_reactResponsiveCarousel.Carousel, {
      autoPlay: autoPlay,
      showArrows: arrows,
      showThumbs: thumbs,
      showStatus: status,
      infiniteLoop: infinite,
      interval: interval,
      transitionTime: transitionTime,
      dynamicHeight: true
    }, messages && messages.map(message => renderMessage(message)));
  }
  return /*#__PURE__*/_react.default.createElement("div", null, messages && messages.map(message => renderMessage(message)));
});
var _default = exports.default = SiteMessages;
SiteMessages.propTypes = {
  className: _propTypes.default.string,
  type: _propTypes.default.oneOf(Object.values(SiteMessageType)).isRequired,
  showSpinner: _propTypes.default.bool,
  carousel: _propTypes.default.bool,
  arrows: _propTypes.default.bool,
  autoPlay: _propTypes.default.bool,
  thumbs: _propTypes.default.bool,
  status: _propTypes.default.bool,
  infinite: _propTypes.default.bool,
  interval: _propTypes.default.number,
  transitionTime: _propTypes.default.number
};
//# sourceMappingURL=SiteMessages.js.map